import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreModule } from 'app/core/core.module';
import { CustomerComponent } from './pages/customer/customer.component';
import { CustomerRoutingModule } from './customer-routing.module';
import { SiteListModule } from '@components/site-list/site-list.module';
import { CustomerGridComponent } from './components/customer-grid/customer-grid.component';
import { CustomerDetailComponent } from './components/customer-detail/customer-detail.component';
import { ContractDetailComponent } from './components/contract-detail/contract-detail.component';
import { ContractSliceModule } from './components/contract-slice/contract-slice.module';
import { ContractConcessionModule } from './components/contract-concession/contract-concession.module';
import { ContractCreationModule } from './components/contract-creation/contract-creation.module';

@NgModule({
  imports: [
    CommonModule,
    CustomerRoutingModule,
    CoreModule,
    SiteListModule,
    ContractSliceModule,
    ContractConcessionModule,
    ContractCreationModule
  ],
  declarations: [
    CustomerComponent,
    CustomerGridComponent,
    CustomerDetailComponent,
    ContractDetailComponent
  ]
})
export class CustomerModule { }
